import { render } from "./AutoRestart.vue?vue&type=template&id=53257e02&scoped=true"
import script from "./AutoRestart.vue?vue&type=script&lang=js"
export * from "./AutoRestart.vue?vue&type=script&lang=js"

import "./AutoRestart.vue?vue&type=style&index=0&id=53257e02&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53257e02"]])

export default __exports__